import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux';
import { Document } from 'react-pdf'


import {
    exibirDocumento
} from '../../actions'

class ModalPDF extends Component {
    constructor(props){
        super(props)

        this.state = {
            modalIsOpen: true,
            file: undefined
        }

        this.closeModal = this.closeModal.bind(this);
        
    }

    componentDidMount(){
        const { documento } = this.props.documentos
        if(documento != undefined)
            this.props.exibirDocumento(documento.id)
    }
    
    closeModal() {
        this.props.closeModal()
        //this.setState({modalIsOpen: false});
    }

    downloadPDF(pdf) {
        const linkSource = `data:application/pdf;base64,${encodeURI(pdf)}`;
        const downloadLink = document.createElement("a");
        const fileName = "teste.pdf";
    
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }
    
    render(){
        var { /*exibir_doc_load, exibir_doc,*/ documento } = this.props.documentos
        var file = true//undefined
        // var fileURL = undefined
        // fileURL = `data:application/pdf;base64,${exibir_doc}`

        // if(exibir_doc != undefined){
        //     file = new Blob([exibir_doc], {type: 'application/pdf'})
        //     fileURL = URL.createObjectURL(file)    
        // }
        
        var fileURL = documento.url_documento;
        console.log('=> TESTE: ', fileURL)
        
        return(
            <div className="modal fade bd-example-modal-xl" id="modalSeeDoc" tabIndex="-1" role="dialog"
                aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modalSendDoc">Visualizar documento</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {file != undefined
                                ?<embed style={customStyles.framePDF} src={fileURL} type='application/pdf' frameBorder="0" width="100%" height="600" /> 
                                :<div className="d-flex justify-content-center">
                                    {/* {exibir_doc_load
                                        ?<div className="spinner-border" role="status" style={{margin:'1%'}}>
                                        </div>
                                        :'Nenhum arquivo PDF encontrado.'
                                    } */}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ documentos }) => {
    return {
        documentos
    }
}

export default connect(mapStateToProps, {
    exibirDocumento
})(ModalPDF);

const customStyles = {
    main: {
        paddingLeft: '2%',
        paddingRight: '2%'
    },
    modal:{
        width:'50%',
        // height: '50%',
        left:'35%',
        top: '80px',
    },
    framePDF: {
        // width:'100%',
        // height:'100%',
        // padding:'2%'
    },
    container: {
        width:'100%',
        height:'100%',
    }
}